export const analyticsEvents = {
  TRACK_CREATE_NEW_ACCOUNT: 'create_new_account_pressed',
};
